var AbstractDataModel = require("./AbstractDataModel")
var CustomScreenFieldModel = require("./CustomScreenFieldModel");
var getQueryParam = require("../helpers/viewmodels").getQueryParam

/**
 * @class CustomScreenModel
 */
function CustomScreenModel(obj, messageBroker) {
  var self = this;
  self.messageBroker = messageBroker;
  self.hasRequiredFields = false;

  AbstractDataModel.apply(self, arguments);

  if (obj) {
    self = Object.assign(self, obj);

    if (getQueryParam('debug') === 'true') {
      self.data = obj;
    }

    /**
     * @type Array<CustomScreenFieldModel>
     */
    self.fields = []; //ko.observableArray([]);
    self.includeConsumerName = obj.includeConsumerName || false;
    self.rawFields = []; //ko.observableArray([]);
    self.rawTitle = obj.title;
    self.requiredBeforeAppointment = obj.requiredBeforeAppointmentSelection || false;

    if (obj.field) {
      if (obj.field.constructor === Object) {
        // setting CustomScreen.includeConsumerName is creating some
        // double fields. I'm not sure I agree with this logic.
        // For now, just ignore any fields with an ID less than 1
        if (obj.field.id > 0) {
          self.fields.push(new CustomScreenFieldModel(obj.field, self));
        }
      }
      else if (obj.field.constructor === Array) {
        obj.field.forEach(function (field) {
          // setting CustomScreen.includeConsumerName is creating some
          // double fields. I'm not sure I agree with this logic.
          // For now, just ignore any fields with an ID less than 1
          if (field.id > 0) {
            self.fields.push(new CustomScreenFieldModel(field, self));
          }
        });
      }
    }

    self.hasRequiredFields = self.fields.filter(function (f) {
      return f.required;
    }).length > 0;

    // Because we may be manipulating the fields() collection based on
    // the location parameter includeConsumerName, the fields at init
    // are stored in this collection so that the observables can be
    // correctly cleared later.
    self.rawFields = self.fields.slice(0);
  }

  /**
   * This method looks through the CustomScreenModel's fields collection
   * and tries to match the fieldName passed with a name property in each
   * field. If found, it will return the corresponding id value, or null
   * if an id was not found
   *
   * @method getFieldIdByName
   * @param {String} sFieldName
   * @param {Number|Null} Id of the field
   */
  self.getFieldIdByName = function (sFieldName) {
    sFieldName = sFieldName ? sFieldName.replace('customscreenfield_', '') : '';

    var field = self.fields.find(function (field) {
      return field.name === sFieldName;
    });

    return field ? field.id : null;
  };


  /**
   * Returns the descriptive text describing the custom screen
   *
   * @method title
   * @return {String}
   */
  self.title = ko.computed(function () {
    // Try first to get the localized name from the Message table
    var langTitle = self.messageBroker.get('customScreen.' + self.name + '.title');
    if (langTitle != '') {
      return langTitle;
    }
    // Next try to get the localized id from the Message table
    langTitle = self.messageBroker.get('customScreen.' + self.id + '.title');
    if (langTitle != '') {
      return langTitle;
    }
    // Just return whatever you have as the title from the JSON
    return self.rawTitle;
  });



  /**
   * Whether this screen has fields that can alter which queues
   * will be shown to the user
   *
   * @method hasQueueFilteringFields
   * @returns {Boolean}
   */
  self.hasQueueFilteringFields = function () {
    return self.fields.filter(function (field) {
      return field.hasQueueFilteringOptions();
    }).length > 0;
  };


  /**
   * Returns a boolean value indicating whether any of the fields on the
   * screen require validation against server-held props
   *
   * @method mustValidateCustomProps
   * @return {Boolean}
   */
  self.mustValidateCustomProps = function () {
    var fieldsRequireValidation = self.fields.filter(function (field) {
      return (field.mustMatchExisting === true || field.enableWhitelist === true)
    }).length > 0;

    return (fieldsRequireValidation || self.requiresHostValidation === true);
  };


  /**
   * Indicates if the screen only contains button fields, in which case
   * the UI will be rendered differently
   *
   * @method onlyButtons
   * @returns {Boolean}
   */
  self.onlyButtons = function () {
    var buttons = self.fields.filter(function (f) {
      return f.type === 'button'
    });

    return self.fields.length === buttons.length;
  };


  /**
   * Method to set custom screen fields back to null for next consumer
   *
   * @method resetFields
   * @return none
   */
  self.resetFields = function () {
    self.rawFields.forEach(function (rawField) {
      rawField.reset();
    });
  };

  this.attr = function () {
    return {
      id: "detail-customscreen-" + self.name
    }
  }

  return self;

};

CustomScreenModel.prototype = Object.create(AbstractDataModel.prototype);
CustomScreenModel.prototype.constructor = CustomScreenModel;

module.exports = CustomScreenModel
